import React from 'react';
import { BRAND_WORDMARK } from '@/theme/brand.paths';

type Props = {
    height?: number;
    className?: string;
    title?: string;
    accent?: string;
    ink?: string;
};

const BrandWordmark: React.FC<Props> = ({ height, className, title, accent = 'var(--mantine-primary-color-filled)', ink = 'var(--bd-text-strong)' }) => (
    <svg
        viewBox={BRAND_WORDMARK.viewBox}
        preserveAspectRatio="xMinYMid meet"
        width={height ? height * BRAND_WORDMARK.ratio : undefined}
        height={height}
        className={className}
        role={title ? 'img' : undefined}
        aria-hidden={title ? undefined : true}
        focusable="false"
        style={{ display: 'block', flexShrink: 0, aspectRatio: String(BRAND_WORDMARK.ratio) }}
    >
        {title ? <title>{title}</title> : null}
        <path fill={accent} d={BRAND_WORDMARK.accent} />
        <path fill={ink} d={BRAND_WORDMARK.ink} />
    </svg>
);

export default BrandWordmark;
